// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import iView from 'iview';
import store from './store/index';
import 'iview/dist/styles/iview.css';
import Lockr from 'lockr';
import axios from 'axios'
import api from "./serve/api"
import serve from "@/serve/serve"
import VueClipboard from 'vue-clipboard2'
import util from "@/util/util"
import baseData from "@/util/baseData"

import $ from 'jquery'
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.use(iView);
window.Lockr = Lockr
window.axios = axios
window.api = api
window.util = util
window.serve = serve
window.baseData = baseData
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created(){
    // let crm_token = '7bbdf69a39311d4715d052935383145a90a74cc6dfaa7fb8fb7e6d8681de69e8'
    let crm_token = util.getQueryVariable("crm_token")
    $.ajax({
      url:api.login,//url路径
      type:'GET', //GET
      async:false, //或false,是否异步
      data:{//参数
        crm_token:crm_token
      },
      timeout:5000, //超时时间
      dataType:'json', //返回的数据格式：
      beforeSend:function(xhr){
      },
      success:function(data,textStatus,jqXHR){

        window.token = data.access_token
        window.token_type = data.token_type
        window.agent_info = data.agent_info
        window.menuList = data.menus
      },
      error:function(xhr,textStatus){
        window.location.href = api.erpUrl
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js